export interface WarehouseStationOption {
    id: number;
    code: string;
    name: string;
    position: string;
    group: 'press' | 'load';
}

export const WAREHOUSE_STATIONS: WarehouseStationOption[] = [
    { id: 1, code: 'A', name: 'Station A', position: 'A', group: 'press' },
    { id: 2, code: 'B', name: 'Station B', position: 'B', group: 'press' },
    { id: 3, code: 'C', name: 'Station C', position: 'C', group: 'press' },
    { id: 4, code: 'D', name: 'Station D', position: 'D', group: 'press' },
    { id: 5, code: 'Load 1', name: 'Station Load 1', position: 'Load 1', group: 'load' },
    { id: 6, code: 'Load 2', name: 'Station Load 2', position: 'Load 2', group: 'load' },
    { id: 7, code: 'Load 3', name: 'Station Load 3', position: 'Load 3', group: 'load' },
    { id: 8, code: 'Load 4', name: 'Station Load 4', position: 'Load 4', group: 'load' },
];

export function warehouseStationLabel(
    id: number | string | null | undefined,
): string {
    const n = Number(id);
    return WAREHOUSE_STATIONS.find((station) => station.id === n)?.name || '';
}

export function warehouseStationOption(
    id: number | string | null | undefined,
): WarehouseStationOption | undefined {
    const n = Number(id);
    return WAREHOUSE_STATIONS.find((station) => station.id === n);
}
